module.exports = __webpack_public_path__ + "static/media/fedpa-off-app-provider-icon.21974221.svg";